import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {CrmAddressBookMemberLinkContainerModel} from '../../../../../../models/aggregates/crm/address/crm-address-book-member-link-container.model';

@Injectable({providedIn: 'root'})
export class CrmAddressBookMemberLinkService extends BaseApiTemplateService<CrmAddressBookMemberLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'address-book-member-link';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'address-book-member-link';
    this.httpClient = http;
  }

}
